<!--
 * @Author: M.D.
 * @Date: 2019-12-09 13:44:18
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="logo-header">
    <div class="wrapper">
      <div class="logo-wrapper">
        <div class="left">
          <img class="logo-img" src="@/assets/image/qjwx_log.png" alt="LOGO" />
        </div>
        <div class="right">
          <div class="t main-text">企业服务平台</div>
          <div class="t subtext">A trusted plantform</div>
        </div>
      </div>
      <div class="center_menu">
        <div class="entries entries1">
          <ul class="ul">
            <router-link :to="{ name: 'index' }" tag="li" class="item"
              >首页</router-link
            >
            <router-link :to="{ name: 'qyfw' }" tag="li" class="item"
              >企业服务</router-link
            >
            <router-link :to="{ name: 'qypx' }" tag="li" class="item"
              >企业培训</router-link
            >
            <router-link :to="{ name: 'news' }" tag="li" class="item"
              >最新资讯</router-link
            >
            <router-link :to="{ name: 'category' }" tag="li" class="item"
              >商品分类</router-link
            >
            <!--<router-link :to="{name:'myProd'}" tag="li" class="item">我的产品</router-link>-->
          </ul>
        </div>
        <div class="entries entries2">
          <ul class="ul">
            <a class="hd-btn" href="skpkp://kp">税控盘开票</a>
            <a class="as-btn" @click="checkQDP">全电发票</a>
            <!-- <a class="dn-btn" @click="toDownload">下载</a> -->
            <!-- <a class="hd-btn" href="hd://E:\hd.reg">税控盘开票</a> -->
            <!-- <a class="hd-btn" href="ukeykp://kp">UKEY开票</a> -->
            <!-- <span class="hd-btn" @click="headerBtnClick(0)">税控盘开票</span>
              <span class="hd-btn" @click="headerBtnClick(1)">UKEY开票</span> -->
          </ul>
        </div>
        <div class="search-wrapper">
          <div class="search_w">
            <div class="search-icon" @click="search()">
              <span class="iconfont icon-search"></span>
            </div>
            <input
              type="text"
              class="search-input"
              autocomplete="off"
              placeholder="请输入要搜索的商品信息"
              :value="searchTxt"
              @input="search"
              @keyup.enter.exact="search"
              ref="searchInput"
            />

            <!-- 防止自动补全 -->
            <div style="opacity:0">
              <input style="width:0;height:0" type="text" />
              <!-- <el-input style="width:0;height:0"  v-model="keyw" placeholder="请输入内容"></el-input> -->
            </div>
          </div>
        </div>
      </div>

      <div class="loginclass">
        <LoginU
          ref="login"
          @loginResult="loginResult"
          @openCompDialog="openCompDialog"
          @openLoginDialog="openLoginDialog"
          @openPay="openPay"
        ></LoginU>

        <!-- <div><el-button type="primary" size="medium">下载</el-button></div> -->
        <!-- <ul class="ul">
              <a class="login-btn" href="ukeykp://kp">登录</a>
              <a class="zhuce-btn" href="ukeykp://kp">立即注册</a>
            </ul> -->
      </div>

      <div v-if="payQuandian">
        <PayCode @openPay="openPay" @openpaymoney="openpaymoney"></PayCode>
      </div>
    </div>
  </div>
</template>

<script>
import PayCode from '@/components/buyQR'
import API from '@/api/api'
import { mapGetters, mapActions } from 'vuex'
import LoginU from '@/components/logo_login'
import { usrStatus } from '@/util/mixin'

export default {
  mixins: [usrStatus],
  props: {},
  data() {
    return {
      keyw: '',
      payQuandian: false,
    }
  },
  computed: {
    ...mapGetters(['searchTxt', 'userInfo']),
  },
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    ...mapActions(['setSearchTxt']),
    headerBtnClick(type) {
      if (type === 0) {
        console.log('税控')
      } else {
        console.log('ukey')
      }
    },
    search() {
      // alert(this.$refs.searchInput.value)
      this.setSearchTxt(this.$refs.searchInput.value)
      if (this.$router.name !== 'category') {
        // this.$router.replace({ name: 'category', query: { q: this.searchTxt } }).catch(err => {
        //   console.log(err)
        // })
        this.$router.replace({ name: 'category' }).catch(err => {
          console.log(err)
        })
      }
    },
    toLogin() {
      this.$refs.login.toLogin()
    },
    toRegist() {
      this.$refs.login.goRegister()
    },
    perfectInfo() {
      this.$refs.login.perfectInfo()
    },
    loginResult() {
      this.$emit('loginResult', true)
    },
    openCompDialog() {
      this.$emit('openCompDialog', true)
    },
    openLoginDialog() {
      this.$emit('openLoginDialog', true)
    },
    openpaymoney() {
      this.payQuandian = false
      //this.$emit('openpaymoney', true)
    },
    //校验是否可以开qdp
    checkQDP() {
      location.href =
        'https://www.chinaqjwx.cn/qjyweb/#/cloudLogin'
      return
      if (!this.isLogin) {
        this.$emit('openLoginDialog', true)
        return
      }
      if (this.userInfo.dzswjzh) {
        this.openPay()
        //调用一键登录
      } else {
        this.$alert('您还未完善全电相关信息，请先完善信息', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showClose: false,
        }).then(() => {
          //完善信息
          this.$router.push({
            name: 'userInfo',
            query: { op: 'qd' },
          })
        })
      }
    },
    //
    toDownload() {},
    //一键登录
    openPay() {
      console.log(this.userInfo)

      let request = {
        creditCode: this.userInfo.creditCode,
        memberId: this.userInfo.id,
        isJson: true,
      }
      API.qdyjdl(request).then(res => {
        console.log(res)
        if (res.data.statusCode == 201) {
          this.$alert(res.data.message, '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false,
          })
          this.payQuandian = !this.payQuandian
        } else if (res.data.statusCode == 200) {
          this.$nextTick(() => {
            window.open(res.data.result.url)
          })
          // setTimeout(() => {
          //   window.open(res.data.result.url)
          // }, 2000)

          //window.location.href = res.data.result.url
          //跳转
        } else {
          this.$message(res.data.message)
        }
      })
    },
  },
  components: {
    LoginU,
    PayCode,
  },
}
</script>

<style lang="stylus" scoped>
.logo-header {
  background-color: #ffffff;
  height: 96px;
  width: 100%;

  .wrapper {
    width: 1700px;
    margin: auto;
    display: flex;
    height: 96px;

    .logo-wrapper {
      width: 200px;
      // flex: 0 0 222px;
      // background-color red
      // box-sizing: border-box;
      // padding: 0 15px;
      center();
      flex-ltr-parent();

      .left {
        height: 41px;
      }

      .logo-img {
        display: inline-block;
        height: 41px;
        width: 40px;
      }

      .right {
        .t {
          text-align: center;
        }

        .main-text {
          color: #333333;
          font-size: 24px;
          font-family: AdobeHeitiStd-Regular;
          height: 24px;
          line-height: 1;
        }

        letter-spacing: 0px;

        .subtext {
          color: #333333;
          padding-top: 5px;
          font-size: 14px;
          height: 13px;
          line-height: 1;
          font-family: AdobeHeitiStd-Regular;
        }
      }
    }

    .entries {
      // flex: 1 1 auto;
      // background-color green
      .ul {
        flex-right();
        height: 100%;

        .item {
          display: flex;
          align-items: center;
          height: 100%;
          margin-right: 26px;
          color: #333333;
          font-family: AdobeHeitiStd-Regular;
          font-size: 23px;

          &:hover {
            cursor: pointer;
            color: #ff7a00;
          }

          &.router-link-active {
            color: #ff7a00;
            border-bottom: 2px solid #ff7a00;
          }
        }

        .hd-btn {
          // margin: 0 5px;
          color: #ff7a00;
          border: 1px solid #ff7a00;
          border-radius: 15px;
          font-size: 14px;
          margin-right: 8px;
          // padding: 8px 4px;
          width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          text-decoration: none;

          &:hover {
            cursor: pointer;
            background-color: #ff7a00;
            color: white;
          }
        }
  .as-btn {
          // margin: 0 5px;
          color: #67C23A;
          border: 1px solid #67C23A;
          border-radius: 15px;
          font-size: 14px;
          margin-right: 8px;
          // padding: 8px 4px;
          width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          text-decoration: none;

          &:hover {
            cursor: pointer;
            background-color: #67C23A;
            color: white;
          }
        }

          .dn-btn {
          // margin: 0 5px;
          color: #67C23A;
          border: 1px solid #67C23A;
          border-radius: 15px;
          font-size: 14px;
          margin-right: 8px;
          // padding: 8px 4px;
          width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          text-decoration: none;

          &:hover {
            cursor: pointer;
            background-color: #67C23A;
            color: white;
          }
        }


      }
    }

    .entries1 {
    }

    .entries2 {
      flex: 1 1 auto;
    }

    .search-wrapper {
      flex: 0 0 280px;
      margin-left: 27px;
      center();

      .search_w {
        height: 36px;
        border-radius: 18px;
        border: solid 1px #999999;
        width: 100%;
        display: flex;
        align-items: center;

        .search-icon {
          height: 18px;
          width: 18px;
          margin-left: 15px;
        }

        .search-input {
          height: 28px;
          width: 220px;
          background: transparent;
          border: none;
          // border-bottom: 1px solid #cccccc;
          font-size: 14px;
          outline: none;
        }
      }
    }

    .loginclass {
      center();
      justify-content: space-between;

      .ul {
        flex-right();

        .login-btn {
          color: #ff7a00;
          border: 1px solid #ff7a00;
          border-radius: 18px;
          font-size: 24px;
          margin-right: 20px;
          width: 80px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          text-decoration: none;

          &:hover {
            cursor: pointer;
            background-color: #ff7a00;
            color: white;
          }
        }

        .zhuce-btn {
          color: #999999;
          font-size: 24px;
          width: 96px;
          height: 22px;
          line-height: 24px;
          text-align: center;
          text-decoration: none;
          font-family: AdobeHeitiStd-Regular;

          &:hover {
            cursor: pointer;
            color: #ff7a00;
          }
        }
      }
    }
  }
}

.center_menu {
  width: 1050px;
  display: flex;
  margin-left: 50px;
  margin-right: 20px;
}
</style>
